import { useMatch } from 'react-router-dom';

export const useCompanyOrOrganizationMatch = () => {
  const companyMatch = useCompanyMatch();
  const organizationMatch = useOrganizationMatch();

  return companyMatch ?? organizationMatch;
};

export const useCompanyMatch = () => {
  return useMatch({
    path: '/company/:companyId',
    end: false
  });
};

export const useOrganizationMatch = () => {
  const organizationMatch = useMatch({
    path: '/hall-of-companies/workspace/:workspaceId/organization/:organizationId',
    end: false
  });

  const organizationMatchRetro = organizationMatch && {
    ...organizationMatch,
    params: {
      ...organizationMatch.params,
      companyId: organizationMatch.params.organizationId
    }
  };
  return organizationMatchRetro;
};

export const useWorkspaceMatch = () => {
  const hallOfWorkspaceMatch = useMatch({
    path: '/hall-of-companies/workspace/:workspaceId',
    end: false
  });

  let workspaceMatch = useMatch({
    path: '/workspace/:workspaceId',
    end: false
  });

  workspaceMatch = hallOfWorkspaceMatch ?? workspaceMatch;
  const workspaceMatchRetro = workspaceMatch && {
    ...workspaceMatch,
    params: {
      ...workspaceMatch.params
    }
  };
  return workspaceMatchRetro;
};

export const useHallOfWorkspaceMatch = (end = true) => {
  return useMatch({
    path: '/hall-of-companies',
    end
  });
};

export const useReaIntegrationMatch = () => {
  return useMatch({
    path: '/company/:companyId/property/:propertyId/integrations/rea/*',
    end: false
  });
};

export const useRegionalOverviewMatch = () => {
  return useMatch({
    path: '/company/:companyId/regional-overview/*',
    end: false
  });
};

/**
 * Registered under three paths - a workspace, an organization, and a property inside one - so the
 * three are asked about together rather than at each call site.
 */
export const useReportsListMatch = () => {
  const workspaceReports = useMatch({ path: '/workspace/:workspaceId/reports-list', end: true });
  const organizationReports = useMatch({ path: '/company/:companyId/reports-list', end: true });
  const propertyReports = useMatch({ path: '/company/:companyId/property/:propertyId/reports-list', end: true });

  return workspaceReports ?? organizationReports ?? propertyReports;
};

export const useRiskManagementMatch = () => {
  return useMatch({
    path: '/risk-management/:companyId',
    end: false
  });
};

export const useScoutingScoreMatch = () => {
  return useMatch({
    path: '/company/:companyId/property/:propertyId/scouting-score',
    end: true
  });
};
